export default __webpack_public_path__ + "static/media/640_dummy2016-kuenstler02-de.15e251e2.png";